import { render, staticRenderFns } from "./comment-view.vue?vue&type=template&id=c80c82f8&scoped=true"
import script from "./comment-view.vue?vue&type=script&lang=js"
export * from "./comment-view.vue?vue&type=script&lang=js"
import style0 from "./comment-view.vue?vue&type=style&index=0&id=c80c82f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80c82f8",
  null
  
)

export default component.exports